module.exports = __webpack_public_path__ + "static/img/l2.7bdc7746.png";